import React from "react";

/**
 * Shared section heading: small uppercase overline, tracking-tight
 * headline, and muted subtitle. `dark` flips colors for navy sections.
 */
export default function SectionHeading({
  overline,
  title,
  subtitle,
  dark = false,
  align = "center",
  className = "",
}) {
  const alignCls = align === "left" ? "text-left" : "mx-auto text-center";
  return (
    <div className={`max-w-2xl ${alignCls} ${className}`}>
      {overline && (
        <p
          className={`text-xs font-bold uppercase tracking-[0.22em] ${
            dark ? "text-blue-300" : "text-primary"
          }`}
        >
          {overline}
        </p>
      )}
      <h2
        className={`mt-3 text-3xl font-bold tracking-tight sm:text-4xl ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-4 text-base leading-relaxed ${
            dark ? "text-slate-300" : "text-slate-500"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
